import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  Popover,
  Box,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { AssetFilterOptions } from "@config/client/filter-options";

export const AssetMenuPopover = (props) => {
  const { anchorEl, onClose, open, onFilter, ...other } = props;
  const { t } = useTranslation();
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "right",
        vertical: "bottom",
      }}
      transformOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
      disableScrollLock
      disableAutoFocus
      disableEnforceFocus
      onClose={onClose}
      open={!!open}
      slotProps={{
        paper: {
          sx: {
            maxWidth: 320,
            padding: 1,
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
          },
        },
      }}
      {...other}
    >
      <Typography variant="caption" sx={{ px: 1, fontWeight: 700, textTransform: "uppercase", color: "text.secondary" }}>
        {t("client.filter")}
      </Typography>
      <Box sx={{ mt: 0.5, pt: 1, borderTop: "1px solid", borderColor: "divider" }}>
        {AssetFilterOptions.map((filter) => (
          <ListItemButton
            key={filter.key}
            onClick={() => {
              onFilter(filter.key);
              onClose();
            }}
            sx={{
              borderRadius: 1,
              px: 1,
              py: 0.25,
              minHeight: 32,
            }}
            data-testid="asset-filter-option"
          >
            <ListItemText
              sx={{ my: 0 }}
              primary={
                <Typography variant="body2" >{t(filter.name)}</Typography>
              }
            />
          </ListItemButton>
        ))}
      </Box>
    </Popover>
  );
};
AssetMenuPopover.propTypes = {
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onFilter: PropTypes.func.isRequired,
};
